export default "__VITE_ASSET__lP7w7quC__"